module.exports = __webpack_public_path__ + "img/remove-Onhold.27720b33.svg";